import PropTypes from "prop-types"
import React from "react"
import Month from "../Views/Month"
import Week from "../Views/Week"
import Day from "../Views/Day"

const getCalendarComponent = () => {
  return { month: Month, week: Week, date: Day }
}

const CalendarViewSwitcher = ({ date, range, bookingsData, journalNoteDates, timeOffData, loading, onJournalClick }) => {
  if (!date || !range) return null

  const Calendar = getCalendarComponent()[range]

  return (
    <Calendar
      date={date}
      bookingsData={bookingsData}
      journalNoteDates={journalNoteDates}
      timeOffData={timeOffData}
      loading={loading}
      onJournalClick={onJournalClick}
    />
  )
}

CalendarViewSwitcher.propTypes = {
  date: PropTypes.string.isRequired,
  range: PropTypes.string.isRequired,
  bookingsData: PropTypes.array,
  journalNoteDates: PropTypes.array,
  timeOffData: PropTypes.array,
  loading: PropTypes.bool,
  onJournalClick: PropTypes.func
}

export default CalendarViewSwitcher
